import { useState, useEffect } from "react";

function useIsIPhone() {
  const [isIPhone, setIsIPhone] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;

    if (/iPhone|iPad|iPod/.test(userAgent) && !window.MSStream) {
      setIsIPhone(true);
    }
  }, []);

  return isIPhone;
}

export default useIsIPhone;
